import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
	path: '/',
	redirect: '/Productlandingpage'
  },{
	  path: '/PinjamCepat',
	  name: 'PinjamCepat',
	  component: () => import('@/page/Pinjam/PinjamCepat')
  },{
	  path: '/LandingPage',
	  name: 'LandingPage',
	  component: () => import('@/page/Pinjam/LandingPage')
  },{//第三个app的落地页
	  path: '/Productlandingpage',
	  name: 'Productlandingpage',
	  component: () => import('@/page/Pinjam/Productlandingpage')
  }
]

const router = new VueRouter({
  routes
})

export default router